var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('material-card',{attrs:{"color":"secundary","text":""}},[_c('Titulo',{attrs:{"empresa":_vm.empresa}}),_c('Menu',{attrs:{"empresa":_vm.empresa}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }